import React from "react";
import { Inbox } from "lucide-react";

const HistoryEmpty = ({ statusFilter }) => {
    let title = "No entries found";
    let description = "Try adjusting the filters to see more results.";
    if (statusFilter === "backlog") {
        title = "No overdue tasks — nice work!";
        description = "Everything in this range is up to date.";
    } else if (statusFilter === "current") {
        title = "Nothing current in this range";
        description = "There are no measurements or open slots for the selected dates.";
    }
    return (
        <div
            data-testid="history-empty"
            className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-white/60 px-6 py-16 text-center"
        >
            <Inbox className="h-8 w-8 text-slate-400" />
            <p className="mt-3 text-sm font-bold text-slate-800">{title}</p>
            <p className="mt-1 text-xs text-slate-500">{description}</p>
        </div>
    );
};

export default HistoryEmpty;
